<div class="bg-lightGrayish flex flex-col px-6 max-lg:mb-5">
  <div class="text-veryFaintBlack flex items-center max-lg:justify-between">
    <p class="w-28 text-xs font-semibold lg:w-[85%] lg:text-base">
      {{ firstText }} <br />
      {{ secondText }}
    </p>
    @if (type === UserOverviewType.BIRTHDAY) {
      <p
        class="flex w-64 justify-end border-l-2 text-xs font-semibold whitespace-nowrap text-black max-sm:w-28 lg:text-base xl:min-w-[5rem]"
      >
        {{ getShortEmployeeName(nextBirthdayData.firstname + ' ' + nextBirthdayData.lastname) }}
        {{ nextBirthdayData.birthdate }}
      </p>
    } @else if (currentEmployee && type === UserOverviewType.OVERTIME) {
      <p
        class="flex w-64 justify-end border-l-2 text-xs font-semibold whitespace-nowrap text-black max-sm:w-28 lg:text-base xl:min-w-[5rem]"
      >
        {{ helperService.formatMinutes(currentEmployee.overtimeBalance) }}
        Hours
      </p>
    } @else if (currentEmployee && type === UserOverviewType.VACATION) {
      <p
        class="flex w-64 justify-end border-l-2 text-xs font-semibold whitespace-nowrap text-black max-sm:w-28 lg:text-base xl:min-w-[5rem]"
      >
        {{ currentEmployee.vacationDays }}
        Days
      </p>
    } @else if (type === UserOverviewType.LEAVES_TODAY) {
      <div class="flex w-64 min-w-max flex-col">
        <div
          [title]="leavesOfTodayTitle"
          class="flex max-h-[70px] flex-col items-end overflow-hidden border-l-2 text-xs font-semibold text-ellipsis text-black max-sm:w-28 lg:text-base xl:min-w-[5rem]"
        >
          @if (leavesOfToday.length > 0) {
            @for (leave of leavesOfToday; track leave) {
              <p>
                {{ getShortEmployeeName(leave.employeeName) }}
              </p>
            }
          } @else {
            <p>-</p>
          }
        </div>
        @if (leavesOfToday.length > 3) {
          <span class="text-end leading-none text-black">...</span>
        }
      </div>
    }
  </div>
</div>
